/* @flow */

export const ETAPA_AGUARDANDO_PAGAMENTO = 1;
export const ETAPA_EM_ANALISE = 2;
export const ETAPA_PAGA = 3;
export const ETAPA_DISPONIVEL = 4;
export const ETAPA_EM_DISPUTA = 5;
export const ETAPA_DEVOLVIDA = 6;
export const ETAPA_CANCELADA = 7;
export const ETAPA_VENCIDA = 8;

export const STATUS_PENDENTE = 'pending';
export const STATUS_PAGO = 'paid';
export const STATUS_CANCELADO = 'canceled';
export const STATUS_EXPIRADO = 'expired';
export const STATUS_DEVOLVIDA = 'refunded';
export const STATUS_AUTORIZADA = 'authorized';
export const STATUS_EM_DISPUTA = 'in_protest';
export const STATUS_PARCIALMENTE_PAGA = 'partially_paid';
export const STATUS_CHARGEBACK = 'chargeback';
